import { render, staticRenderFns } from "./SelectLdapGroupModal.vue?vue&type=template&id=99c81e24&"
import script from "./SelectLdapGroupModal.vue?vue&type=script&lang=js&"
export * from "./SelectLdapGroupModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports